"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentType = exports.IBookingStatus = void 0;
const tslib_1 = require("tslib");
// @TODO: Move to booking type
var IBookingStatus;
(function (IBookingStatus) {
    IBookingStatus["draft"] = "drafting";
    IBookingStatus["negotiation"] = "negotiating";
    IBookingStatus["reserved"] = "reserved";
    IBookingStatus["canceled"] = "canceled";
    IBookingStatus["ongoing"] = "ongoing";
    IBookingStatus["completed"] = "completed";
})(IBookingStatus = exports.IBookingStatus || (exports.IBookingStatus = {}));
// @TODO: Move to booking type
var PaymentType;
(function (PaymentType) {
    PaymentType["payment"] = "payment";
    PaymentType["return"] = "refund";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
tslib_1.__exportStar(require("../store/interfaces"), exports);
tslib_1.__exportStar(require("../store/bookings/interfaces"), exports);
tslib_1.__exportStar(require("../store/items/interfaces"), exports);
tslib_1.__exportStar(require("../store/user/interfaces"), exports);
//# sourceMappingURL=index.js.map